import styled, { css } from 'styled-components'

import { Typography } from '@/components/ui/typography'

export const Row = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['12']};
    padding: ${theme.space['12']} ${theme.space['16']};
    background: ${theme.colors.white};
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
    max-width: 72rem;
    width: 100%;

    &:hover {
      border-color: ${theme.colors.gray600};
    }
  `,
)

export const DragHandle = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: grab;
    color: ${theme.colors.black300};
    flex-shrink: 0;
  `,
)

export const IconWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    color: ${theme.colors.black500};
  `,
)

export const Name = styled(Typography)`
  flex: 1 1 30%;
  min-width: 0;
`

export const Value = styled.a(
  ({ theme }) => css`
    flex: 1 1 70%;
    min-width: 0;
    font-size: 1.4rem;
    color: ${theme.colors.blue500};
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  `,
)

export const EditIcon = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    flex-shrink: 0;
    color: ${theme.colors.black400};
    cursor: pointer;
    width: ${theme.space['32']};
    height: ${theme.space['32']};
    border-radius: ${theme.border.radius.circle};
    transition: background-color ${theme.transition.duration.sm} ease;

    &:hover {
      background-color: ${theme.colors.gray400};
    }
  `,
)
